module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hedo-01.b15a609c.png";